/** Scroll containers inside GlobalNavigationShell (desktop main column + mobile wrappers). */
const SHELL_SCROLL_CONTAINER_SELECTORS = [
  ".global-navigation-shell__content",
  ".global-navigation-shell__mobile-content",
  ".global-navigation-shell__mobile-container",
].join(", ");

/** Resets window/document scroll and common in-app scroll containers (e.g. dashboard main column). */
export function resetScrollPosition(): void {
  globalThis.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelectorAll<HTMLElement>(SHELL_SCROLL_CONTAINER_SELECTORS).forEach((el) => {
    el.scrollTop = 0;
  });
}
